import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import Alert from "react-bootstrap/Alert";
import {openSale} from "../../../../../_helpers/tabOpeners";
import {Button} from "react-bootstrap";

const FixedAssetSalesCorrelation = ({fixedAsset, unHookCallback}) => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);

    const handleDehook = () => {
        unHookCallback();
    }

    return (
        <React.Fragment>
            {!isEmpty(fixedAsset.correlatedSale) ? (
                <Alert variant={"secondary"}>
                    Συσχετιζόμενο με την πώληση: <strong onClick={() => openSale(dispatch, TABS_DATA, company.id, fixedAsset.correlatedSale)} style={{textDecoration: "underline", textDecorationStyle: "dotted", cursor: "pointer"}}>{fixedAsset.correlatedSaleLabel}</strong>,
                    γραμμή: <strong>{fixedAsset.correlatedSaleRowNumber}</strong>
                    <Button size={"sm"} onClick={() => handleDehook()} className={"ml-2"}>Αποσυσχέτιση</Button>
                </Alert>
            ) : (
                <></>
            )}
        </React.Fragment>
    )
}

export default FixedAssetSalesCorrelation;
